import { render, staticRenderFns } from "./IconDefault.vue?vue&type=template&id=8d61a15e&scoped=true&"
import script from "./IconDefault.vue?vue&type=script&lang=js&"
export * from "./IconDefault.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8d61a15e",
  null
  
)

export default component.exports